import { createFileRoute } from '@tanstack/react-router';

import { Heading } from '@/common/components/heading';
import { Seo } from '@/common/components/seo';
import { requireAuth } from '@/shared/auth';

export const Route = createFileRoute('/feeds/$feedId')({
  beforeLoad: ({ location, context }) => {
    requireAuth({ location, auth: context.auth });
  },
  component: FeedDetailRoute
});

function FeedDetailRoute() {
  const { feedId } = Route.useParams();

  return (
    <>
      <Seo title={`Feed ${feedId}`} />
      <div className="flex w-full flex-wrap items-end justify-between gap-4 border-b border-zinc-950/10 pb-6 dark:border-white/10">
        <Heading>Feed Details</Heading>
      </div>
      <div className="mt-8">
        <p className="text-gray-600">
          Feed ID:
          {feedId}
        </p>
        {/* TODO: Add feed detail component */}
      </div>
    </>
  );
}
